var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "hotspotCutoutStyle" },
    [
      _c("div", { staticClass: "header" }, [
        _c("h2", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "image-list" },
        _vm._l(_vm.datas.imageList, function (image, index) {
          return _c(
            "div",
            { key: image.id || index, staticClass: "image-item" },
            [
              _c(
                "div",
                { staticClass: "item-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        icon: "el-icon-delete",
                        type: "danger",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteImage(index)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              image.url
                ? _c("div", { staticClass: "image-preview" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.resPath + image.url,
                        alt: image.name || "图片",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.previewImage(index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "image-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              icon: "el-icon-delete",
                              type: "danger",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clearImage(index)
                              },
                            },
                          },
                          [_vm._v("清除")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("div", { staticClass: "image-upload" }, [
                    _c(
                      "div",
                      {
                        staticClass: "upload-placeholder",
                        on: {
                          click: function ($event) {
                            return _vm.handleImageClick(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-plus upload-icon" }),
                        _vm._v(" "),
                        _c("p", { staticClass: "upload-text" }, [
                          _vm._v("点击上传图片"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "upload-tip" }, [
                          _vm._v("建议尺寸：750×360像素"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput-" + index,
                      refInFor: true,
                      staticStyle: { display: "none" },
                      attrs: { type: "file", accept: "image/*" },
                      on: {
                        change: function ($event) {
                          return _vm.handleFileChange($event, index)
                        },
                      },
                    }),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "image-right" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("链接设置")]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      placeholder: "图片提示信息（非必填）",
                      size: "small",
                    },
                    model: {
                      value: image.altText,
                      callback: function ($$v) {
                        _vm.$set(image, "altText", $$v)
                      },
                      expression: "image.altText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: !image.url,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openHotspotDialog(index)
                        },
                      },
                    },
                    [_vm._v("添加热区")]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-image-btn", on: { click: _vm.addNewImage } },
        [_vm._v("\n    + 添加配置\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "more-setting" }, [
        _c(
          "div",
          { staticClass: "more-title", on: { click: _vm.toggleMoreSetting } },
          [
            _vm._v("\n      更多设置\n      "),
            _c("i", {
              class: _vm.showMoreSetting
                ? "el-icon-arrow-up"
                : "el-icon-arrow-down",
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMoreSetting,
                expression: "showMoreSetting",
              },
            ],
            staticClass: "setting-content",
          },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "80px", size: "small" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "图片样式" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.datas.imgStyle,
                          callback: function ($$v) {
                            _vm.$set(_vm.datas, "imgStyle", $$v)
                          },
                          expression: "datas.imgStyle",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("常规"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("投影"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "图片倒角" } },
                  [
                    _c("el-slider", {
                      attrs: {
                        max: 50,
                        "input-size": "mini",
                        "show-input": "",
                      },
                      model: {
                        value: _vm.datas.borderRadius,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "borderRadius", $$v)
                        },
                        expression: "datas.borderRadius",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "左右边距" } },
                  [
                    _c("el-slider", {
                      attrs: {
                        max: 100,
                        min: 0,
                        "input-size": "mini",
                        "show-input": "",
                      },
                      model: {
                        value: _vm.datas.pagePadding,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "pagePadding", $$v)
                        },
                        expression: "datas.pagePadding",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "图片宽度" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        max: 750,
                        step: 1,
                        placeholder: "0 为自适应",
                        size: "small",
                      },
                      model: {
                        value: _vm.datas.imgWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "imgWidth", $$v)
                        },
                        expression: "datas.imgWidth",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          color: "#909399",
                          "font-size": "12px",
                        },
                      },
                      [_vm._v("px（0 自适应）")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "图片高度" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        max: 1000,
                        step: 1,
                        placeholder: "0 为自适应",
                        size: "small",
                      },
                      model: {
                        value: _vm.datas.imgHeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "imgHeight", $$v)
                        },
                        expression: "datas.imgHeight",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          color: "#909399",
                          "font-size": "12px",
                        },
                      },
                      [_vm._v("px（0 自适应）")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置热区",
            visible: _vm.showHotspotDialog,
            width: "800px",
            "before-close": _vm.cancelAddHotspot,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showHotspotDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "hotspot-dialog-content" }, [
            _c("div", { staticClass: "image-preview-container" }, [
              _c(
                "div",
                { staticClass: "image-header" },
                [
                  _c("h4", [_vm._v("选择热区区域")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.addNewHotspot },
                    },
                    [_vm._v("+ 添加热区")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.datas.imageList[_vm.currentImageIndex] &&
              _vm.datas.imageList[_vm.currentImageIndex].url
                ? _c(
                    "div",
                    { staticClass: "image-preview-wrapper" },
                    [
                      _c("img", {
                        ref: "hotspotImage",
                        staticClass: "hotspot-image",
                        attrs: {
                          src:
                            _vm.resPath +
                            _vm.datas.imageList[_vm.currentImageIndex].url,
                          alt:
                            _vm.datas.imageList[_vm.currentImageIndex].name ||
                            "热区图片",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.datas.imageList[_vm.currentImageIndex].hots,
                        function (hotspot, index) {
                          return _c(
                            "div",
                            {
                              key: "existing-" + hotspot.id,
                              class: [
                                "existing-hotspot",
                                {
                                  selected:
                                    _vm.selectedHotspot &&
                                    _vm.selectedHotspot.id === hotspot.id,
                                },
                              ],
                              style: {
                                left: hotspot.x + "%",
                                top: hotspot.y + "%",
                                width: hotspot.width + "%",
                                height: hotspot.height + "%",
                              },
                              on: {
                                mousedown: function ($event) {
                                  return _vm.startMoving($event, hotspot)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "hotspot-label" }, [
                                _vm._v(_vm._s(hotspot.title)),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-se",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "se"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-n",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "n"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-e",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "e"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-s",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "s"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-w",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "w"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-ne",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "ne"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-nw",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "nw"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "resize-handle resize-handle-sw",
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.startResizing(
                                      $event,
                                      hotspot,
                                      "sw"
                                    )
                                  },
                                },
                              }),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _c("div", { staticClass: "no-image-placeholder" }, [
                    _c("p", [_vm._v("暂无图片，请先上传图片")]),
                  ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "hotspot-config" },
              [
                _c("h4", [_vm._v("热区配置")]),
                _vm._v(" "),
                _c(
                  "el-form",
                  { attrs: { "label-width": "100px", size: "small" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "热区名称" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入热区名称" },
                          on: { input: _vm.updateHotspot },
                          model: {
                            value: _vm.selectedHotspot.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedHotspot, "title", $$v)
                            },
                            expression: "selectedHotspot.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转地址" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入小程序页面路径" },
                          on: { input: _vm.updateHotspot },
                          model: {
                            value: _vm.selectedHotspot.link,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedHotspot, "link", $$v)
                            },
                            expression: "selectedHotspot.link",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "hotspot-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.deleteSelectedHotspot },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelAddHotspot } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmAddHotspot },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desc" }, [
      _c("div", { staticClass: "desc-title" }, [_vm._v("添加图片")]),
      _vm._v(" "),
      _c("div", { staticClass: "desc-tip" }, [
        _vm._v("\n      建议图片尺寸宽度750，高度不限制。\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }